// src/components/Odontograma/hooks/useOdontograma.ts
import { useCallback, useState } from "react";
import { Piece, ToothSection } from "../types/piece.types";
import { SectionId, SectionColors } from "../types/types";

const DEFAULT_COLOR = "#D1D5DB";

export const useOdontograma = (initialPieces: Piece[] = []) => {
  const [selected, setSelected] = useState<SectionId[]>(
    initialPieces.map((p) => `${p.idDiente}-${p.seccion}` as SectionId)
  );

  const [colors] = useState<SectionColors>(
    () =>
      Object.fromEntries(
        initialPieces.map((p) => [`${p.idDiente}-${p.seccion}`, DEFAULT_COLOR])
      ) as SectionColors
  );

  /** ¿Está seleccionada cierta sección? */
  const isSelected = useCallback(
    (id: SectionId) => selected.includes(id),
    [selected]
  );

  /** Alterna una sección individual o ALL */
  const toggle = useCallback((toothId: string, section: ToothSection) => {
    const id = `${toothId}-${section}` as SectionId;
    const allId = `${toothId}-ALL` as SectionId;

    setSelected((prev) => {
      const s = new Set(prev);

      if (section === "ALL") {
        // si ALL ya estaba, lo quito; si no, quito todo lo demás y pongo ALL
        if (s.has(allId)) s.delete(allId);
        else {
          [...s].forEach((k) => {
            if (k.startsWith(`${toothId}-`)) s.delete(k);
          });
          s.add(allId);
        }
      } else {
        // sección individual
        if (s.has(allId)) s.delete(allId);
        if (s.has(id)) s.delete(id);
        else s.add(id);
      }

      return Array.from(s);
    });
  }, []);

  /** Selecciona TODO el diente (borra las secciones individuales y marca ALL) */
  const selectAll = useCallback((toothId: string) => {
    const allId = `${toothId}-ALL` as SectionId;
    setSelected((prev) => {
      const s = new Set(prev);
      [...s].forEach((k) => {
        if (k.startsWith(`${toothId}-`)) s.delete(k);
      });
      s.add(allId);
      return Array.from(s);
    });
  }, []);

  return {
    selected,
    colors,
    isSelected,
    toggle,
    selectAll, // <-- lo añadimos al return
  };
};
